import { parseMessages } from 'helpers/parse-dll-error'
import { AxiosResponse } from 'axios'
import _ from 'lodash'

export const getRespData = (res: AxiosResponse, rejectWithValue: Function | null, singleRes = false) => {
    let data: any = undefined
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            if (rejectWithValue) {
                throw rejectWithValue(parseMessages(res.data.messages))
            }
        } else {
            if (res.data.hasOwnProperty('data')) { // if the response conatins a data element then return it
                data = res.data.data
            } else { // if the response does not contain data element, the return response, but remove the status field
                data = _.omit(res.data, 'status')
            }
        }
    } else {  // backend response
        data = res.data
    }

    if (singleRes && data) {
        if (!data || (Array.isArray(data) && data.length === 0)) {
            if (rejectWithValue) {
                throw rejectWithValue('No data found')
            }
        } else {
            return Array.isArray(data) ? data[0] : data
        }
    } else {
        return data
    }
}
